import { useCallback, useEffect, useState } from 'react'
import { useStreetsQuery } from '../../../../api/options/hooks'
import { Step2FormProps, Step2FormStreetProps } from '../types'

const useStep2FormStreet = (form: Step2FormProps['form']): Step2FormStreetProps => {
    const city = form.watch('objectCity')
    const zip = form.watch('objectZIP')
    const street = form.watch('objectStreet')
    const [streetSearch, setStreetSearch] = useState<string | undefined>(street)
    const handleStreetSearchChanged = useCallback((s: string) => setStreetSearch(s), [])
    useEffect(() => {
        setStreetSearch(street)
    }, [street])

    const { data, isLoading } = useStreetsQuery(streetSearch, city, zip)

    return {
        streetSearch,
        handleStreetSearchChanged,
        streets: data || [],
        isLoading,
    }
}

export default useStep2FormStreet
